var map = {
	"./af-ZA": 100,
	"./af-ZA.js": 100,
	"./ar": 101,
	"./ar.js": 101,
	"./bg": 102,
	"./bg.js": 102,
	"./ca": 103,
	"./ca.js": 103,
	"./cz": 104,
	"./cz.js": 104,
	"./da": 105,
	"./da.js": 105,
	"./de": 106,
	"./de.js": 106,
	"./ee": 107,
	"./ee.js": 107,
	"./el": 108,
	"./el.js": 108,
	"./en": 109,
	"./en.js": 109,
	"./es": 110,
	"./es.js": 110,
	"./fa": 111,
	"./fa.js": 111,
	"./fi": 112,
	"./fi.js": 112,
	"./fr": 113,
	"./fr.js": 113,
	"./he": 114,
	"./he.js": 114,
	"./id": 115,
	"./id.js": 115,
	"./it": 116,
	"./it.js": 116,
	"./ja": 117,
	"./ja.js": 117,
	"./ko": 118,
	"./ko.js": 118,
	"./lv": 119,
	"./lv.js": 119,
	"./nb-NO": 120,
	"./nb-NO.js": 120,
	"./nl": 121,
	"./nl.js": 121,
	"./pl": 122,
	"./pl.js": 122,
	"./pt": 124,
	"./pt-br": 123,
	"./pt-br.js": 123,
	"./pt.js": 124,
	"./ru-RU": 125,
	"./ru-RU.js": 125,
	"./sk": 126,
	"./sk.js": 126,
	"./sl": 127,
	"./sl.js": 127,
	"./sv-SE": 128,
	"./sv-SE.js": 128,
	"./ta": 129,
	"./ta.js": 129,
	"./th": 130,
	"./th.js": 130,
	"./tk": 131,
	"./tk.js": 131,
	"./tr-TR": 132,
	"./tr-TR.js": 132,
	"./ua": 133,
	"./ua.js": 133,
	"./vi": 134,
	"./vi.js": 134,
	"./zh-CN": 67,
	"./zh-CN.js": 67,
	"./zh-TW": 135,
	"./zh-TW.js": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/locale/lang ^\.\/.*$
// module id = 99
// module chunks = 1